import React from 'react';
import { Outlet } from 'react-router-dom';
import { TiersOfferProvider } from '@europrocurement/l2d-modules';

const CRMRoot: React.FunctionComponent = function () {
    return (
        <TiersOfferProvider>
            <Outlet />
        </TiersOfferProvider>
    );
};

export default CRMRoot;
